import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'info-small', 'IconInfoSmall', [["path",{"d":"M12 9h.01","key":"svg-0"}],["path",{"d":"M11 12h1v4h1","key":"svg-1"}]]);